import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CallToAction() {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="relative py-24 bg-gradient-to-br from-green-900 to-emerald-800 overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-1.2.1&auto=format&fit=crop&w=2560&q=80"
          alt="Collaboration"
          className="w-full h-full object-cover opacity-20"
        />
      </div>

      <div className="relative max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
            Join Us in Shaping the Future
          </h2>
          <p className="text-green-100 text-lg md:text-xl leading-relaxed mb-12 max-w-2xl mx-auto">
            Together, we can create impactful, sustainable solutions for Africa's climate challenges. 
            Be part of our mission to build a resilient future.
          </p>
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Link
              to="/contact#top"
              onClick={handleClick}
              className="inline-flex items-center px-8 py-4 bg-white text-green-900 rounded-full text-lg font-semibold hover:bg-green-50 transition-colors group"
            >
              Get Involved
              <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform" />
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}